import { render } from "./JoinUsIcon.vue?vue&type=template&id=313d72ce&ts=true"
import script from "./JoinUsIcon.vue?vue&type=script&lang=ts"
export * from "./JoinUsIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__